/* eslint @typescript-eslint/no-var-requires: "off" */
import React, { Fragment } from 'react';
import { enableMapSet } from 'immer';
import { Provider } from 'react-redux';
import { createRoot } from 'react-dom/client';

import App from 'containers/App';
import NotificationsPortal from 'portals/Notifications';
import store from './store/store';

// import './assets/scss/tailwindcss.scss';
import './assets/scss/global-styles.scss';
import './assets/scss/feather-icons.scss';
import './assets/scss/iransans.scss';
import './assets/css/peyda.css';
import './assets/scss/materialize-rtl.scss';
import './assets/scss/quill.snow.scss';
import './assets/js/myMaterialize';
import './assets/scss/custom-styles.scss';
import './assets/scss/buildtailwindcss.scss';
import './assets/scss/PeydaPersianNumeric.scss';
import GuideFloatButton from './components/GuideFloatBox';
import { storeForThisUserWithTempLogin } from './store/thisUser/thisUserSlice';
import { register } from './serviceWorker';

export { store };

enableMapSet();

// Set local storage
store.subscribe(() => {
  const state = store.getState();
  const useLocalStorage = state.thisUser.useLocalStorage;
  const storage = useLocalStorage
    ? localStorage
    : storeForThisUserWithTempLogin;

  storage.setItem('thisUser', JSON.stringify(state.thisUser));
  localStorage.setItem(
    'isSideBarCollapsed',
    JSON.stringify(state.app.UI.sidebar.isSideBarCollapsed)
  );
});

const renderApp = (Component: React.ComponentType<any>) => {
  const container = document.getElementById('app');
  if (!container) {
    throw new Error('Root element not found');
  }
  const root = createRoot(container);

  root.render(
    <Provider store={store}>
      <Fragment>
        <Component />
        <NotificationsPortal />
        {!window.location.pathname.includes('/direct/') &&
          !window.location.pathname.includes('/dt/') &&
          !window.location.hash.includes('#chat') && <GuideFloatButton />}
      </Fragment>
    </Provider>
  );
};

renderApp(App);

if (module.hot) {
  module.hot.accept('./containers/App', () => {
    const NextApp = require('./containers/App').default;
    renderApp(NextApp);
  });
}

// Register the service worker
register({
  onSuccess: (_registration) => {
    /*console.log('Service worker registered successfully:', registration);*/
  },
  onUpdate: (_) => {
    /*console.log('New update available. Please refresh the page.');*/
  },
});
